import { Injectable } from '@angular/core';
import {
  GlobalSearchConfigService,
  I18nService,
  LuigiCoreService,
} from '@openmfp/portal-ui-lib';

@Injectable({ providedIn: 'root' })
export class DxpGlobalSearchConfigService implements GlobalSearchConfigService {
  constructor(
    private luigiCoreService: LuigiCoreService,
    private i18nService: I18nService,
  ) {}

  getGlobalSearchConfig() {
    return {
      searchFieldCentered: true,
      searchProvider: {
        onEnter: () => {
          this.onEnter();
        },
        onSearchBtnClick: () => {
          this.onEnter();
        },
        onEscape: () => {
          this.luigiCoreService.globalSearch().clearSearchField();
          this.luigiCoreService.globalSearch().closeSearchField();
        },
      },
    };
  }

  private onEnter() {
    this.luigiCoreService
      .navigation()
      .pathExists('/search')
      .then((pathExists: boolean) => {
        if (pathExists) {
          this.luigiCoreService
            .navigation()
            .navigate(
              '/search/workspaces?q=' +
                this.luigiCoreService.globalSearch().getSearchString(),
            );
        } else {
          const settings = {
            text: this.i18nService.getTranslation('SEARCH_NOT_AVAILABLE'),
            type: 'error',
            closeAfter: 3000,
          };
          this.luigiCoreService.ux().showAlert(settings);
        }
        this.luigiCoreService.globalSearch().clearSearchField();
        this.luigiCoreService.globalSearch().closeSearchField();
      });
  }
}
